<mat-tab-group #tabGroup headerPosition="above" disableRipple="true" [@.disabled]="true" (selectedTabChange)="onSelectTab($event)">
  <!-- <mat-tab label="FBOs" #businessesTab>
      <app-business-listing [businesses]="airport.businesses"></app-business-listing>
  </mat-tab> -->
  <mat-tab label="Local Attractions" #attractionsTab>
    <!-- <ng-container *ngIf="selectedTab === attractionsTab">
      <app-local-attractions [airport]="airport"></app-local-attractions>
    </ng-container> -->
    <ng-template matTabContent>
      <app-local-attractions [airport]="airport"></app-local-attractions>
    </ng-template>
  </mat-tab>
  <mat-tab label="Local Activities" #activitiesTab>
    <!-- <ng-container *ngIf="selectedTab === activitiesTab">
      <app-local-activities [airport]="airport"></app-local-activities>
    </ng-container> -->
    <ng-template matTabContent>
      <app-local-activities [airport]="airport" [tabType]="'activities'"></app-local-activities>
    </ng-template>
  </mat-tab>
  <mat-tab label="Restaurants" #activitiesTab>
    <!-- <ng-container *ngIf="selectedTab === activitiesTab">
      <app-local-activities [airport]="airport"></app-local-activities>
    </ng-container> -->
    <ng-template matTabContent>
      <app-local-activities [airport]="airport" [tabType]="'restaurant'"></app-local-activities>
    </ng-template>
  </mat-tab>
  <mat-tab label="Hotels and Lodging" #activitiesTab>
    <!-- <ng-container *ngIf="selectedTab === activitiesTab">
      <app-local-activities [airport]="airport"></app-local-activities>
    </ng-container> -->
    <ng-template matTabContent>
      <app-local-activities [airport]="airport" [tabType]="'lodging'"></app-local-activities>
    </ng-template>
  </mat-tab>
  <mat-tab *ngIf="!isIslandSource" label="Travel Discounts" #affiliationsTab>
    <!-- <ng-container *ngIf="selectedTab === affiliationsTab">
      <app-travel-affiliations [airport]="airport"></app-travel-affiliations>
    </ng-container> -->
    <ng-template matTabContent>
      <app-travel-affiliations [airport]="airport"></app-travel-affiliations>
    </ng-template>
  </mat-tab>
</mat-tab-group>
